<template>
    <div class="row" style = "margin-left: -30px; margin-right: -30px;">
        <div class="w-100">{{ 'bonus_stage' | lang }}</div>
        <table class ="table" style="border:none; table-layout: fixed;"> 
            <tr class="" v-for="(row, index) in bonusStages" :key="index">
                <td v-for="(scenario, index) in row" :key="index" :style="`border: 1px solid rgba(255,255,255,0.3);padding: 7px; vertical-align: middle;`">
                    <img style = "height: 20px;" v-if = "!scenario.bonus_stage.guess" :src="`/sl/v1/games/book_of_einikis/img/X-red.png`" alt="X" class="img-fluid">
                    <div class="" v-else> 
                        <span v-for="(item, index) in parseNumbers(scenario.bonus_stage.guess)" :key="index">
                            <img :src="`/sl/v1/games/book_of_einikis/img/${item}.png`" :alt="item" class="img-fluid" :style="`height: 20px; ${['Dot', 'Comma'].includes(item) ? 'padding-top: 15px; height:auto; width:8px;' : ''}`">
                        </span>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    props: ['scenarios', 'amount'],
    data() {
        return {
        };
    },
    methods: {
        parseNumbers(number) {
            let wonAmount = parseInt(number) * this.amount;

            if(Math.round(wonAmount) == wonAmount) {
                wonAmount = Math.round(wonAmount);
            }

            let amountSymbolsCount = String(wonAmount);
            let items = [];

            for (let i = 0; i < amountSymbolsCount.length; i++) {
                let spriteName = amountSymbolsCount[i];

                switch(amountSymbolsCount[i]) {
                    case '.':
                        spriteName = 'Dot';
                        break;
                    case ',':
                        spriteName = 'Comma';
                        break;
                }

                items.push(spriteName);
            }

            return items;
        }
    },
    computed: {
        bonusStages() {
            let filtered = this.scenarios.filter(function (scenario) {
                return scenario.bonus_stage;
            }).sort((a, b) => new Date(b.datetime_updated) - new Date(a.datetime_updated));

            let table = [];
            let inserted = 0;

            for(let i = 1; i <= 3; i++) {
                table[i] = [];

                for(let j = 1; j <= 3; j++) {
                    table[i].push(filtered[inserted]);
                    inserted++;
                }
            }

            return table;
        }
    },
}
</script>